import React from "react";
import { Paper, Stack, Typography, Box, Button } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddIcon from "@mui/icons-material/Add";

import TaskStats from "./TaskStats";
import TaskList from "./TaskList";
import InfoButton from "./InfoButton";
import { HELP_CONTENT } from "../../constants/clinicalHelpContent";

/**
 * Panel 6: My Tasks Today
 * Task stats + grouped task list + new task button.
 */
export default function PanelTasks({
  tasks,
  stats,
  loading,
  onComplete,
  onCancel,
  onDelete,
  onEdit,
  onNewTask,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        height: "100%",
      }}
    >
      <Stack spacing={2}>
        {/* Header */}
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 28,
                height: 28,
                borderRadius: 1.5,
                bgcolor: "#EFF6FF",
                color: "#2563EB",
              }}
            >
              <AssignmentIcon sx={{ fontSize: 16 }} />
            </Box>
            <Typography variant="subtitle2" fontWeight={700}>
              My Tasks
            </Typography>
            <InfoButton helpContent={HELP_CONTENT.tasks} />
          </Stack>
          <Button
            size="small"
            startIcon={<AddIcon sx={{ fontSize: 14 }} />}
            onClick={onNewTask}
            sx={{
              textTransform: "none",
              fontSize: "0.72rem",
              borderRadius: 2,
            }}
          >
            New Task
          </Button>
        </Stack>

        {/* Stats */}
        <TaskStats stats={stats} />

        {/* Task List */}
        <TaskList
          tasks={tasks}
          loading={loading}
          onComplete={onComplete}
          onCancel={onCancel}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      </Stack>
    </Paper>
  );
}
